import { AxiosError, AxiosResponse, default as axios } from 'axios';
import { ReleasesResponse, FaqsResponse, CheckIntegrationKeyResponse, AnalyticsUser, Tier } from '../Model';
import * as status from 'http-status-codes';
import { logError } from './ecommscriptClient';
import { Auth } from '@trustpilot/ecommscript-integrationappauth';
import { Tools } from '../Tools';

const api = process.env.REACT_APP_SettingsApiUrl;
const headers = { 'Content-Type': 'application/json' };

export const getReleases = (source: string): Promise<ReleasesResponse[] | undefined> =>
    axios
        .get(`${api}/api/settings/${source.toLowerCase()}/releases`, { headers })
        .then((response: AxiosResponse<ReleasesResponse[]>) => {
            return response.data;
        })
        .catch((err: AxiosError) => {
            logError(err);
            return undefined;
        });

export const getFaqs = (source: string): Promise<FaqsResponse[] | undefined> =>
    axios
        .get(`${api}/api/settings/${source.toLowerCase()}/faqs`, { headers })
        .then((response: AxiosResponse<FaqsResponse[]>) => {
            return response.data;
        })
        .catch((err: AxiosError) => {
            logError(err);
            return undefined;
        });

export const checkTemporaryConfig = (key: string): Promise<CheckIntegrationKeyResponse | undefined> =>
    axios
        .get(`${api}/api/settings/${key}/check`, { headers })
        .then((response: AxiosResponse<CheckIntegrationKeyResponse>) => {
            return response.data;
        })
        .catch((err: AxiosError) => {
            logError(err);
            return undefined;
        });

export const getAnalyticsUserId = (email: string): Promise<AnalyticsUser | undefined> =>
    axios
        .get(`${api}/api/settings/${email}/uniqueid`)
        .then((res: AxiosResponse<AnalyticsUser>) => {
            if (res.status === status.OK) {
                return res.data;
            } else {
                throw new Error(`Failed to get analytics user. Reason: ${res.data}`);
            }
        }).catch((err: AxiosError) => {
            logError(err);
            return undefined;
        });

export const getTierInfo = (businessUnitId: string): Promise<string | undefined> => {
    const requestHeaders = {
        Authorization: `Bearer ${Auth.getAccessToken()}`,
    };
    return axios
        .get(`${api}/api/settings/${businessUnitId}/tier`, { headers: requestHeaders })
        .then((res: AxiosResponse<Tier>) => {
            if (res.status === status.OK) {
                const tierName = res.data ? res.data.name : '';
                return tierName || '';
            } else {
                throw new Error(`Failed to get analytics user. Reason: ${res.data}`);
            }
        }).catch((err: AxiosError) => {
            logError(err);
            Tools.resetTokenIfUnauthorized(err.response);
            return undefined;
        });
};



// WEBPACK FOOTER //
// ./src/Api/settingsApiClient.tsx